const GET_CENTROS_NA_COMPETENCIA = (state) => (competencia) => {
  return collect(state.notas.centros_plain).contains(function (item, key) {
    return collect(item.competencias).contains('id', competencia.id)
  }).all()
}



export default {
  GET_CENTROS_NA_COMPETENCIA
}



// WEBPACK FOOTER //
// ./src/features/Dashboard/store/getters.js